import React, { useContext } from "react";
import FirebaseContext from "../firebase/firebaseContext";

const StudentTeacher = (props) => {
  const hw = props.location.state;
  const firebaseContext = useContext(FirebaseContext);
  const { auth, db } = firebaseContext;

  const taskConfirm = (e) => {
    e.preventDefault();
    db.collection("students")
      .doc(hw.id)
      .update({ ...hw, task: false, points: hw.points + 1 });
  };

  return (
    <div className='student-container'>
      <h1>{hw.name + "'" + "s"} NOTEBOOK</h1>
      <div className='student-info'>
        <p className='ucenec'>Učenec: {hw.name}</p>
        <p className='razred'>Razred: {hw.class}</p>
     
      </div>
      <div className='student-docs'>
        <iframe
          src={hw.source}
          frameborder='0'
          width='1920'
          height='560'
          allowfullscreen='true'
          mozallowfullscreen='true'
          webkitallowfullscreen='true'
        ></iframe>
      </div>
    </div>
  );
};

export default StudentTeacher;
